var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.865 9.0483C25.4915 8.42183 26.5072 8.42183 27.1337 9.0483L45.7192 27.6338C46.3457 28.2603 47.3614 28.2603 47.9878 27.6338C48.6143 27.0074 48.6143 25.9917 47.9878 25.3652L29.4023 6.77966C27.5229 4.90027 24.4758 4.90027 22.5964 6.77967L4.01087 25.3652C3.3844 25.9917 3.3844 27.0074 4.01087 27.6338C4.63733 28.2603 5.65303 28.2603 6.2795 27.6338L24.865 9.0483Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 12.4513L43.4506 29.9025C43.5141 29.966 43.579 30.0275 43.6452 30.0867V43.3433C43.6452 45.5582 41.8497 47.3537 39.6348 47.3537H32.416C31.5301 47.3537 30.8118 46.6355 30.8118 45.7495V36.1245C30.8118 35.2386 30.0936 34.5203 29.2077 34.5203H22.791C21.9051 34.5203 21.1868 35.2386 21.1868 36.1245V45.7495C21.1868 46.6355 20.4686 47.3537 19.5827 47.3537H12.3639C10.149 47.3537 8.35352 45.5582 8.35352 43.3433V30.0867C8.41966 30.0275 8.48457 29.966 8.54813 29.9025L25.9993 12.4513Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fed1e9b6cfe6c5decc27c7d75be820f0.svg";
export { ForwardRef as ReactComponent };